import { AppConfig } from "../../AppConfig";
import { Ticket } from "../../Models/OrderTicket/Ticket";
import { EmailSender } from "./EmailSender";


export class Notifier
{
    constructor(private _emailSender: EmailSender, private _appConfig: AppConfig) 
    { }

    public async OrderCreated(ticket: Ticket): Promise<void>
    {
        if (!ticket)
        {
            return;
        }

        const customerEmail = ticket.Customer.Email;

        if (customerEmail)
        {
            const orderUrl = this._appConfig.GetOrderUrl(ticket.Id);
            const shortOrderId = ticket.Id.slice(-5);

            await this.Notify(customerEmail,
                `specTeam.pl - zamówienie #${shortOrderId}`,
                `Dziękujemy za założenie zamówienia #${shortOrderId} w naszej <b>wypożyczalni sprzętu detektywistycznego <a href="https://specTeam.pl" target="_blank">specTeam.pl</a></b> <br><br>Jego aktualny stan możesz sprawdzić tutaj: <br><a href="${orderUrl}" target="_blank">${orderUrl}</a>`);
        }
    }

    private async Notify(email: string, title: string, message: string): Promise<void>
    {
        await this._emailSender.SendEmail(email, title, message);
    }
}
